module.exports = __webpack_public_path__ + "static/media/port-drive.150b8d15.png";